import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import React from "react";
import SearchField from "../../Form/SearchField";
import { CampaignSearch } from "./CampaignSearch";
export const getEnrollOpportunitiesInCampaignRequest = (formState) => {
    return {
        opportunityIds: formState.opportunityIds,
        campaignId: formState.campaignId,
    };
};
const EnrollOpportunitiesInCampaignForm = ({ virtualizedAppName }) => {
    return (_jsx(_Fragment, { children: _jsx(SearchField, { name: "campaign", label: "Campaign", required: true, as: (provided) => (_jsx(CampaignSearch, Object.assign({}, provided, { isStarted: true, isStopped: false, virtualizedAppName: virtualizedAppName, 
                // @ts-expect-error - TS2322 - Type '{ isStarted: true; virtualizedAppName: string | null | undefined; lite: boolean; placeholder: string | null | undefined; hasError: boolean; errorMessage: string | null | undefined; disabled: boolean | ... 1 more ... | undefined; "aria-label": string; }' is not assignable to type 'IntrinsicAttributes & { id?: string | null | undefined; name?: string | null | undefined; "aria-label": string; formErrors?: any; hasError?: boolean | null | undefined; ... 14 more ...; minNumSearchCharacters?: number | ... 1 more ... | undefined; } & CampaignSearchArgs'.
                lite: true }))) }) }));
};
export default EnrollOpportunitiesInCampaignForm;
